import {JobServiceTypeOptions} from "@pages/job/common/Constant";

export const InteractiveChannel = [
    "",
    "Us emailed mời job",
    "Us emailed",
    "Us called",
    "Us chatted",
    "Person emailed",
    "Person called",
    "Person chatted",
    "Met",
    "Others",
]

export const InteractiveChannelOptions = InteractiveChannel.map(item => {
    return {
        value: item,
        label: item
    };
})

export const CTVStatus = [
    "",
    "GP đề nghị hợp tác",
    "đồng ý hợp tác",
    "từ chối hợp tác",
    "cân nhắc vv hợp tác",
    "sẽ tìm UV",
    "gửi UV",
    "Others",
]

export const CTVStatusOptions = CTVStatus.map(item => {
    return {
        value: item,
        label: item
    };
})

export const AddReferInfoIntoPipelines = [
    "",
    "Đã add vào Pipeline",
    "Đã nằm trong Pipeline",
    "Không phù hợp để add vào Pipeline",
    "Others",
]

export const AddReferInfoIntoPipelinesOptions = AddReferInfoIntoPipelines.map(item => {
    return {
        value: item,
        label: item
    };
})

export const ProcessReferInfo = [
    "",
    "Đã add vào Pipeline",
    "Đã nằm trong Pipeline",
    "Không phù hợp để add vào Pipeline",
    "Others",
]

export const ProcessReferInfoOptions = ProcessReferInfo.map(item => {
    return {
        value: item,
        label: item
    };
})

export const ReferStatus = [
    "",
    "Us xin refer (after email)",
    "Từ chối",
    "50:50",
    "Hứa hẹn nhiệt tình, rõ ràng",
    "Refer có Email",
    "Refer có SĐT, chưa có email",
    "Refer chưa có cả SĐT & email",
    "Rep email - Nói sẽ refer / có UV",
    "Rep email - Hỏi thông tin",
    "Others"
]

export const ReferStatusOptions = ReferStatus.map(item => {
    return {
        value: item,
        label: item
    };
})

export const CddStatus = {
    BLANK: "",
    CALL_NOT_ANSWER: "Call không liên lạc được",
    UV_NOT_PROVIDE_EMAIL: "UV từ chối cung cấp email",
    UV_NOT_CHECK_EMAIL: "UV chưa check mail",
    UV_EMAIL_REPLY: "UV email phản hồi",
    UV_ASK_INFO: "UV hỏi thông tin",
    UV_THINKING: "UV đang cân nhắc",
    UV_PROMISE_REPLY: "Hứa phản hồi",
    UV_LIKE_JOB: "UV quan tâm job",
    UV_PROMISE_SEND_CV: "Hứa gửi CV",
    UV_CONFIRM_AND_CORPORATE: "UV confirm T&C hợp tác",
    UV_APPLY: "UV apply chính thức",
    TO_SEND: "To send",
    UV_REJECT_APPLY: "UV từ chối Apply",
    UV_NOT_OPEN_NEW_JOB: "UV không open new job",
    OTHERS: "Others"
}

export const CddStatusOptions = Object.keys(CddStatus).map(field => {
    return {
        value: CddStatus[field],
        label: CddStatus[field]
    };
})

export const UserQualifyUV = [
    "",
    "L1 - Fit",
    "Referer fit",
    "L2",
    "L3",
    "Chưa rõ",
    "Không đúng yêu cầu - LEVEL",
    "Không đúng yêu cầu - NGÀNH DỌC",
    "Không đúng yêu cầu - PHÂN KHÚC",
    "Không đúng yêu cầu - SỰ CHUYÊN SÂU",
    "Không đúng yêu cầu - NGOẠI NGỮ",
    "Không đúng yêu cầu - KHÁC",
    "Không phù hợp - jump job",
    "Không phù hợp - not strong enough",
    "Không phù hợp - black list",
    "Không phù hợp - khác",
    "Others",
]

export const UserQualifyUVOptions = UserQualifyUV.map(item => {
    return {
        value: item,
        label: item
    };
})

export const TodoWithPersons = {
    BLANK: "",
    TO_CALL: "To call",
    TO_CHAT: "To chat",
    TO_MEET: "To meet",
    TO_FOLLOW_UP: "To follow up",
    TO_REP: "To rep",
    PENDING: "Pending",
    IGNORE: "Ignore",
    DONE_PERIOD_BEFORE_SENDING: "Done period before sending",
    DONE_PROCESS_BEFORE_OFFER: "Done process before offer",
    OTHERS: "Others"
}

export const TodoWithPersonsOptions = Object.keys(TodoWithPersons).map(field => {
    return {
        value: TodoWithPersons[field],
        label: TodoWithPersons[field]
    };
})

export const FullInternalProcess = [
    "",
    "Target",
    "Booked",
    "Booking Rejected",
    "Booking Rejected by PM",
    "Booking Rejected by Ad",
    "Xếp hàng chờ",
    "Emailed mời job",
    "Email giới thiệu by Ad",
    "Email not successfully",
    "Email Rejected by Ad",
    "Call Chat trước vì UV từ chối cho email",
    "Đang trao đổi với UV",
    "Chờ send",
    "Sent to Manager",
    "Others",
]

export const MemberInternalProcess = [
    "",
    "Target",
    "Booked",
    "Booking Rejected",
    "Booking Rejected by PM",
    "Xếp hàng chờ",
    "Emailed mời job",
    "Email not successfully",
    "Call Chat trước vì UV từ chối cho email",
    "Đang trao đổi với UV",
    "Chờ send",
    "Sent to Manager",
    "Others",
]

export const ProcessJobInternalProcess = {
    Target: "Target",
    Booked: "Booked",
    BookedAndEmailedInviteJob: "Booked + Emailed mời job",
    EmailedInviteJob: "Emailed mời job",
    CallChatBefore: "Call Chat trước vì UV từ chối cho email",
    WaitingInLine: 'Xếp hàng chờ',
    WaitingSend: 'Chờ send',
}

export const ProcessJobInternalProcessOptions = Object.keys(ProcessJobInternalProcess).map(key => {
    return {
        value: ProcessJobInternalProcess[key].toLowerCase(),
        label: ProcessJobInternalProcess[key].toLowerCase()
    };
})

export const CannotEditPipelinesWithInternalProcess = [
    "Booked",
    "Emailed mời job",
    "Chờ send",
    "Sent to Manager",
]

export const InternalProcessOptions = FullInternalProcess.map(item => {
    return {
        value: item,
        label: item
    };
})

export const MemberInternalProcessOptions = MemberInternalProcess.map(item => {
    return {
        value: item,
        label: item
    };
})

// export const InternalProcessOptions = InternalProcess.map(item => {
//     return {
//         value: item,
//         label: item
//     };
// })

export const ProcessCddToEmployer = [
    "",
    "Sent to Client",
    "Emp invites Cdd to ITV",
    "Emp rejects CV",
    "Cdd Rejects ITV",
    "Interviewed",
    "Interviewing",
    "UV làm bài tập, presentation,…",
    "Thủ tục trước khi offer (Ref Check, Pay slip,…)",
    "Verbal Offer",
    "Official Offer",
    "Cdd accepts Offer",
    "Cdd rejects Offer",
    "Cdd onboard",
    "Emp cancel offer",
    "Cdd not onboard",
    "Others",
]

export const ProcessCddToEmployerOptions = ProcessCddToEmployer.map(item => {
    return {
        value: item,
        label: item
    };
})

export const PaymentAndWarranty = [
    "",
    "Client confirmed",
    "Issue Invoice",
    "Client paid partly",
    "Client paid all",
    "Finish Guarantee",
    "Cdd leave",
    "Employer dismissed Cdd",
    "Client request Refund",
    "Refund done",
    "Client request Cdd Replacement",
    "Cdd Replacement done",
    "Others",
]

export const PaymentAndWarrantyOptions = PaymentAndWarranty.map(item => {
    return {
        value: item,
        label: item
    };
})

export const JobPipelineTableColumns = [
    {key: 'id', label: 'Pipeline ID', classNames: '', displayType: 'text', inputType: 'number', editable: false, autoAdd: true, searchable: true},
    {key: 'created_date_time', label: 'Note time', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true},
    {key: 'created_user_full_name', label: 'User', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, searchable: false},
    {key: 'candidate_id', label: 'Person ID', classNames: '', displayType: 'link', inputType: 'number', editable: true, link:'/candidate/detail/', searchable: true},
    {key: 'candidate_full_name', label: 'Họ Tên Person', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, capitalize: true, searchable: true},
    {key: 'displayed_company', label: 'Displayed Company', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true, searchable: false},
    {key: 'displayed_title', label: 'Displayed Title', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true, searchable: false},
    {key: 'referer_id', label: 'Referer', classNames: '', displayType: 'link', inputType: 'number', editable: false, link:'/candidate/detail/', searchable: true},
    {key: 'comment_from_referer', label: 'Comment from Referer', classNames: '', displayType: 'text', inputType: 'textarea', editable: true, searchable: true},
    {key: 'employer_id', label: 'Employer ID', classNames: '', displayType: 'link', inputType: 'number', editable: false, autoAdd: true, link:'/employer/edit/', searchable: true},
    {key: 'employer_name', label: 'Employer Name', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, capitalize: true, searchable: true},
    {key: 'job_id', label: 'Job ID', classNames: '', displayType: 'link', inputType: 'number', editable: true, link:'/job/edit/', searchable: true},
    {key: 'job_name', label: 'Job Name', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, capitalize: true, searchable: true},
    {key: 'job_service_type', label: 'Loại DV', classNames: '', displayType: 'text', inputType: 'option', editable: false, autoAdd: true, searchable: true, options: JobServiceTypeOptions},
    {key: 'interactive_channel', label: 'Loại Tương tác', classNames: '', displayType: 'text', inputType: 'option', editable: true, searchable: true, isMulti: false, options: InteractiveChannelOptions},
    // {key: 'ctv_status', label: 'CTV Status', classNames: '', displayType: 'text', inputType: 'option', editable: true, isMulti: false, options: CTVStatusOptions, color: 'text-primary'},
    // {key: 'process_info_from_ctv', label: 'Xử lý thtin from CTV', classNames: '', displayType: 'text', inputType: 'option', editable: true, isMulti: false, options: ProcessInfoFromCTVOptions, color: 'text-primary'},
    // {key: 'input_uv_from_ctv', label: 'Nhập UV fr CTV', classNames: '', displayType: 'link', inputType: 'text', editable: false, autoAdd: true, color: 'text-primary'},
    {key: 'refer_status', label: 'Refer Status', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: ReferStatusOptions, color: 'text-success'},
    // {key: 'add_info_to_pipeline', label: 'Add thtin Refer vào Pipeline', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: [], color: 'text-success'},
    {key: 'refer_info_process', label: 'Xử lý thtin Refer', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: ProcessReferInfoOptions, color: 'text-success'},
    {key: 'referee_id', label: 'Referee', classNames: '', displayType: 'link', inputType: 'number', searchable: true, editable: false, autoAdd: true, link:'/candidate/detail/', color: 'text-success'},
    {key: 'cdd_status', label: 'Cdd Status', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: CddStatusOptions, color: 'text-info'},
    {key: 'user_qualify_uv', label: 'User qualify UV', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: UserQualifyUVOptions},
    // {key: 'suit_level', label: 'Độ phù hợp của UV', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: [], color: 'text-info'},
    {key: 'todo_with_person', label: 'To do w Person', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: TodoWithPersonsOptions, color: 'text-info'},
    {key: 'internal_process', label: 'Process nội bộ', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: InternalProcessOptions, color: 'text-info'},
    {key: 'discussion_with_person_note', label: 'Note Discussion w Person', classNames: '', displayType: 'text', searchable: true, inputType: 'textarea', editable: false, autoAdd: true},
    // {key: 'email_link', label: 'Email Link', classNames: '', displayType: 'link', inputType: 'text', editable: false, autoAdd: true},
    {key: 'cdd_to_employer_process', label: 'Process Cdd to Employer', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: ProcessCddToEmployerOptions, color: 'text-danger'},
    // {key: 'candidate_check_mail_status', label: 'Trạng thái check mail của Emp', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: [], color: 'text-danger'},
    {key: 'payment_and_warranty', label: 'Thanh toán & Bảo hành', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: PaymentAndWarrantyOptions, color: 'text-danger'},
    {key: 'discussion_w_employer_note', label: 'Note Discussion w Employer', classNames: '', displayType: 'text', inputType: 'textarea', searchable: true, editable: false, autoAdd: true, color: 'text-danger'},
    {key: 'notes', label: 'Notes', classNames: '', displayType: 'text', inputType: 'textarea', searchable: true, editable: true},
];

export const SearchJobPipelineFields = [
    {key: 'id', label: 'Pipeline ID', classNames: '', displayType: 'text', inputType: 'number', editable: false, autoAdd: true, searchable: true},
    {key: 'created_date_time', label: 'Note time', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true},

    {key: 'created_user_full_name', label: 'User', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, searchable: false},
    {key: 'candidate_id', label: 'Person ID', classNames: '', displayType: 'link', inputType: 'number', editable: true, link:'/candidate/detail/', searchable: true},
    {key: 'candidate_email', label: 'Person Email', searchable: true, inputType: 'email'},
    {key: 'candidate_phone', label: 'Person SĐT', searchable: true},
    {key: 'candidate_full_name', label: 'Họ Tên Person', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, capitalize: true, searchable: true},
    {key: 'candidate_company', label: 'Họ Tên Person', classNames: '', autoAdd: true, capitalize: true, searchable: true},
    {key: 'candidate_title', label: 'Title', classNames: '', autoAdd: true, capitalize: true, searchable: true},
    {key: 'candidate_general_note', label: 'General Note', classNames: '', searchable: true},
    {key: 'candidate_important_note', label: 'Important Note', classNames: '', autoAdd: true, capitalize: true, searchable: true},

    {key: 'displayed_company', label: 'Displayed Company', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true, searchable: false},
    {key: 'displayed_title', label: 'Displayed Title', classNames: '', displayType: 'text', inputType: 'text', editable: false, capitalize: true, autoAdd: true, searchable: false},
    {key: 'referer_id', label: 'Referer', classNames: '', displayType: 'link', inputType: 'number', editable: false, link:'/candidate/detail/', searchable: true},
    {key: 'comment_from_referer', label: 'Comment from Referer', classNames: '', displayType: 'text', inputType: 'textarea', editable: true, searchable: true},
    {key: 'employer_id', label: 'Employer ID', classNames: '', displayType: 'link', inputType: 'number', editable: false, autoAdd: true, link:'/employer/edit/', searchable: true},
    {key: 'employer_name', label: 'Employer Name', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, capitalize: true, searchable: true},
    {key: 'job_id', label: 'Job ID', classNames: '', displayType: 'link', inputType: 'number', editable: true, link:'/job/edit/', searchable: true},
    {key: 'job_name', label: 'Job Name', classNames: '', displayType: 'text', inputType: 'text', editable: false, autoAdd: true, capitalize: true, searchable: true},
    {key: 'job_service_type', label: 'Loại DV', classNames: '', displayType: 'text', inputType: 'option', editable: false, autoAdd: true, searchable: true, options: JobServiceTypeOptions},
    {key: 'interactive_channel', label: 'Loại Tương tác', classNames: '', displayType: 'text', inputType: 'option', editable: true, searchable: true, isMulti: false, options: InteractiveChannelOptions},
    {key: 'refer_status', label: 'Refer Status', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: ReferStatusOptions, color: 'text-success'},
    {key: 'refer_info_process', label: 'Xử lý thtin Refer', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: ProcessReferInfoOptions, color: 'text-success'},
    {key: 'referee_id', label: 'Referee', classNames: '', displayType: 'link', inputType: 'number', searchable: true, editable: false, autoAdd: true, link:'/candidate/detail/', color: 'text-success'},
    {key: 'cdd_status', label: 'Cdd Status', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: CddStatusOptions, color: 'text-info'},
    {key: 'user_qualify_uv', label: 'User qualify UV', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: UserQualifyUVOptions},
    {key: 'todo_with_person', label: 'To do w Person', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: true, options: TodoWithPersonsOptions, color: 'text-info'},
    {key: 'internal_process', label: 'Process nội bộ', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: InternalProcessOptions, color: 'text-info'},
    {key: 'discussion_with_person_note', label: 'Note Discussion w Person', classNames: '', displayType: 'text', searchable: true, inputType: 'textarea', editable: false, autoAdd: true},
    {key: 'cdd_to_employer_process', label: 'Process Cdd to Employer', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: ProcessCddToEmployerOptions, color: 'text-danger'},
    {key: 'payment_and_warranty', label: 'Thanh toán & Bảo hành', classNames: '', displayType: 'text', inputType: 'option', searchable: true, editable: true, isMulti: false, options: PaymentAndWarrantyOptions, color: 'text-danger'},
    {key: 'discussion_w_employer_note', label: 'Note Discussion w Employer', classNames: '', displayType: 'text', inputType: 'textarea', searchable: true, editable: false, autoAdd: true, color: 'text-danger'},
    {key: 'notes', label: 'Notes', classNames: '', displayType: 'text', inputType: 'textarea', searchable: true, editable: true},
];
